export const LIFE_THREATENING_ALLERGY_REACTIONS = [
  "Anaphylaxis",
  "Breathing difficulties",
  "Seizures",
];
